export enum ErrorCode {
  ACCOUNT_NOT_ACTIVATED = 'ACCOUNT_NOT_ACTIVATED',
  LOGIN_REQUIRES_2FA = 'LOGIN_REQUIRES_2FA',
  INVALID_2FA = 'INVALID_2FA',
}
